export const bandFaqs = [
  {
    question: "دستبند در فعالیت‌های outdoor چطور عمل می‌کند؟",
    answer: "با GPS اپلیکیشن برای ردیابی مسیر و مقاومت در دمای ۰-۵۰ درجه، مناسب کوهنوردی یا دویدن است؛ حسگرهای G-sensor مسافت را دقیق اندازه می‌گیرند. این قابلیت‌ها، ورزشکاران outdoor را با داده‌های قابل اعتماد بدون وابستگی به گوشی یاری می‌رساند."
  },
  {
    question: "آیا دستبندها ضدآب هستند؟",
    answer: "با رتبه IP68 یا ۱ATM، در برابر آب تا عمق ۵۰ متر مقاوم هستند و برای شنا یا تمرینات عرق‌دار مناسب‌اند. این سطح حفاظت، ورزشکاران را از آسیب در فعالیت‌های آبی یا محیط‌های مرطوب حفظ می‌کند بدون کاهش دقت حسگرها."
  },
  {
    question: "چه ویژگی‌های سلامتی پیشرفته‌ای را اندازه‌گیری می‌کنند؟",
    answer: "نظارت ۲۴/۷ بر ضربان قلب، سطح اکسیژن خون (SpO2)، گردش خون، دمای پوست، استرس و کیفیت خواب را پشتیبانی می‌کنند، با تحلیل AI برای گزارش‌های شخصی‌سازی‌شده. برای ورزشکاران، زون‌های ضربان قلب (مانند چربی‌سوزی یا anaerobic) را ردیابی کرده تا عملکرد تمرینی بهینه شود."
  },
  {
    question: "مودهای ورزشی در دستبندها چقدر متنوع هستند؟",
    answer: "بیش از ۵۰ مود ورزشی مانند دویدن، دوچرخه‌سواری و تمرینات قدرتی را پوشش می‌دهند، با ردیابی دقیق شتاب‌سنج برای شمارش قدم، مسافت و کالری. این تنوع، ورزشکاران را در تحلیل عملکرد و تنظیم برنامه‌های تمرینی با داده‌های واقعی یاری می‌رساند."
  },
  {
    question: "دستبند برای ریکاوری پس از تمرین چطور کمک می‌کند؟",
    answer: "با تحلیل کیفیت خواب، سطح ریکاوری بدن و استرس، پیشنهادهایی برای استراحت یا تمرین بعدی ارائه می‌دهد؛ حسگرهای دقیق خواب مراحل (عمیق/سبک) را ردیابی می‌کنند. این ویژگی، ورزشکاران را در جلوگیری از overtraining و بهبود انرژی روزانه یاری می‌رساند."
  },
  {
    question: "آیا دستبند برای نظارت استرس و سلامت قلب مناسب است؟",
    answer: "بله، با پایش مداوم و استرس، هشدارهای شخصی برای مدیریت تنش در تمرینات می‌دهد. برای ورزشکاران، این نظارت دقیق به حفظ سلامت قلب در زون‌های شدت بالا کمک کرده و ریسک آسیب را کاهش می‌دهد."
  }
];